import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useWindow } from '@krp/client-runtime'
import { SALES_POINTS_WINDOWS } from '@krp/resource-receipts-ui'
import { ActionInfo, Tabs } from '@krp/ui-kit'

import { useMyAccess } from '../platform/useMyAccess'

/** Адрес таба «Источники»: вход раздела без него открывает «Магазины». */
const SOURCES_PATH = '/sales-statistics/sources'

const TABS = [
  { id: 'shops', label: 'Магазины' },
  { id: 'sources', label: 'Источники' },
] as const

/**
 * Два таба раздела «Статистика по продажам» (слово владельца 28.10.2026): «Магазины» — первым и по умолчанию, сводная статистика касс
 * разных источников; «Источники» — выбор базы или кабинета и его статистика. Таб — окно на своём адресе, переход заменяет окно.
 */
export function SalesStatisticsTabs({ selected }: { selected: 'sources' | 'shops' }) {
  const window = useWindow()
  const navigate = useNavigate()
  return (
    <ActionInfo id="receipts.sales-points.tabs" label="Магазины и источники" layout="block">
      <Tabs
        label="Статистика по продажам"
        idPrefix="sales-statistics"
        items={TABS}
        selected={selected}
        onSelect={(id) => {
          if (id === selected) return
          if (id === 'shops') window.replaceWith(SALES_POINTS_WINDOWS.list, {})
          else void navigate(SOURCES_PATH, { replace: true })
        }}
      />
    </ActionInfo>
  )
}

/**
 * Шапка входа раздела. Вход без выбора (`/sales-statistics`) открывает «Магазины», если человеку они доступны; таб «Источники» —
 * свой адрес, на нём вход остаётся выбором источника.
 */
export function SalesStatisticsSourcesTabs() {
  const window = useWindow()
  const { pathname } = useLocation()
  const access = useMyAccess()
  const shopsAllowed = access.data?.api.includes('platform:cashiers:read') === true
  const chosen = pathname.endsWith(SOURCES_PATH)
  useEffect(() => {
    if (!chosen && shopsAllowed) window.replaceWith(SALES_POINTS_WINDOWS.list, {})
  }, [chosen, shopsAllowed, window])
  return <SalesStatisticsTabs selected="sources" />
}
